<template>
  <div class="embed-responsive embed-responsive-16by9">
    <div id="player" class="embed-responsive-item video-js vjs-default-skin"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  props: {
    videoId: { type: String, required: true },
    provider: { type: String, required: true },
    isLive: { type: Boolean, default: false },
  },

  data: () => ({
    hasWatchedMinPercent: false,
    watchTimeHistory: {},
    isAutoplay: false,
  }),

  mounted() {
    let watchTimeHistory = localStorage.getItem("classes-watch-time")
    this.watchTimeHistory = JSON.parse(watchTimeHistory) || {}
  },

  computed: {
    ...mapGetters('course', ['courseModuleClass']),

    ...mapGetters('player', ['player']),

    ...mapGetters('user', ['isLogged']),

    videoUrl() {
      return `https://player.vimeo.com/video/${this.videoId}`
    },
  },

  watch: {
    videoId () {
      this.isAutoplay = true
      // this.playPlayer()
      setTimeout(() => this.playPlayer(), 500)
    },

    videoUrl: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.handleWatchPercent())
      },
    },
  },

  methods: {
    ...mapActions("course", ["createCourseClassActivityPercent", 'coureModuleCLass']),

    ...mapActions('player', [
      'loadPlayer',
      'playPlayer',
      'destroyPlayer'
  ]),

    async handleWatchPercent() {
      if (!this.videoId) {
        return null
      }

      try {
        await this.loadPlayer({ id: this.videoId, provider: this.provider})
      } catch (err) {
        console.log("[ERROR - Player] " + err)
        // setTimeout(() => window.location.reload(), 1500)
      }

      if (!this.isLive && !this.courseModuleClass.is_intro) {
        this.handleActivities()
      }
    },

    async handleActivities() {
      this.player.on("play", async () => {
        if (this.isLogged) {
          this.createCourseClassActivityPercent()
        }
      })

      this.player.on("loaded", async () => {       
        this.setCurrentTimeFromTrackClassWathcTime()

        this.hasWatchedMinPercent = false

        if (this.isAutoplay) {
          this.playPlayer()
        }
      })

      this.player.on("timeupdate", async (data) => {
        const percent = (this.player.currentTime() / this.player.duration() * 100).toFixed(0)

        if (!this.isLive) {
          this.trackClassWatchTime(data)
        }

        if (this.isLogged && !this.hasWatchedMinPercent && percent >= 80) {
          this.createCourseClassActivityPercent(80)
          this.hasWatchedMinPercent = true
        }
      })

      this.player.on("ended", async () => {
        if (this.isLogged) {
          this.createCourseClassActivityPercent(100)
        }
      })
    },

    trackClassWatchTime(playerData) {
      const percent = parseFloat((playerData.percent * 100).toFixed(1))
      const seconds = playerData.seconds

      if (this.watchTimeHistory[this.videoId] && this.watchTimeHistory[this.videoId].percent == 100) {
        return null
      }

      this.watchTimeHistory[this.videoId] = { percent, seconds }

      localStorage.setItem("classes-watch-time", JSON.stringify(this.watchTimeHistory))
    },

    setCurrentTimeFromTrackClassWathcTime() {
      const watchTimeHistory = this.watchTimeHistory[this.videoId]

      if (watchTimeHistory && watchTimeHistory.percent < 100) {
        this.player.setCurrentTime(watchTimeHistory.seconds)
      }
    },
  },
}
</script>
